<script setup>
const { $axios } = useNuxtApp()
const userListStore = useUserList()
const { isLoading } = storeToRefs(useLayout())

defineProps({
  showShareModal: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['closed'])

const formData = ref({
  email: '',
  message: '',
})

const generate_message = (userList) => {
  return `
I've put together a list of wines I think you'll love: ${userList.name}.

When you order from Wine Access, you'll get $50 off your first purchase of $150 or more - and trust me, they're by far the best way to discover and enjoy the world's best wines.

Click below to explore my list and claim $50 off your first order.
`.trim()
}

watch(
  () => userListStore.sharingList,
  (newData) => {
    if (newData && Object.keys(newData).length) {
      formData.value.message = generate_message(newData)
    }
  },
)

const close = () => {
  emit('closed')
  formData.value.email = ''
  formData.value.message = generate_message(userListStore.sharingList)
}

const save = async () => {
  const payload = {
    message: formData.value.message,
    email: formData.value.email,
    share_link: userListStore.sharingList.shareLink,
  }

  try {
    isLoading.value = true
    await $axios.post('/api/customer/send_list_share_email/', payload)
    close()
  } catch (e) {
    if (e.response && e.response.status === 400) {
      const errors = {}
      for (const [key, value] of Object.entries(e.response.data)) {
        errors[key] = value.map((x) => `Error: ${x}`)
      }
      setErrors('userlist-share-form', errors)
    } else {
      throw e
    }
  } finally {
    isLoading.value = false
  }
}

const copyLink = () => {
  navigator.clipboard.writeText(userListStore.sharingList.shareLink)
}
</script>
<template>
  <Modal
    :show="showShareModal"
    :classes="{
      modalDialog: 'modal-container list-share-modal',
      modalBody: '',
      modalHeader: '',
      modalFooter: '',
    }"
    @closed="close"
  >
    <template #header>
      <h4>Share Your List</h4>
    </template>
    <template #body>
      <div class="heading">
        <h5>Share "{{ userListStore.sharingList.name }}" & Get $50 Off</h5>
        <p>
          Your friends get $50 off their first order of $150+, and you'll earn
          $50 in wine credit when they buy.
        </p>
      </div>
      <FormKit
        id="userlist-share-form"
        v-model="formData"
        type="form"
        submit-label="Send"
        @submit="save"
      >
        <div class="share-link">
          <label class="formkit-label">
            <span>Share your link anywhere:</span>
            <input type="text" :value="userListStore.sharingList.shareLink" />
          </label>
          <button @click.prevent="copyLink()">Copy</button>
        </div>
        <FormKit
          name="email"
          label="Send an email:"
          type="email"
          validation="required|email"
          :validation-messages="{
            required: 'Error: Email address is required',
          }"
          placeholder="Enter your friend's email address"
        ></FormKit>
        <FormKit name="message" type="textarea" validation="required"></FormKit>
        <p class="terms">
          <nuxt-link href="/terms/">Terms &amp; Conditions</nuxt-link>
        </p>
      </FormKit>
    </template>
  </Modal>
</template>
